import React from 'react'

//* Components
import Header from 'components/Header/Header'
import Footer from 'components/Footer/Footer'
import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher'

//* Pages
import FindYourPhone from './pages/FindYourPhone/FindYourPhone'
import BusinessHome from 'pages/BusinessHome/BusinessHome'
import AboutUs from 'pages/AboutUs/AboutUs'
import Career from 'pages/Career/Career'

//* Router
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//* Styles
/* eslint-disable-next-line no-unused-vars */
import styles from './styles/Main.module.scss'

const RouterWrapper = () => {

  return <Router>
    <Header/>
    <Routes>
      <Route path="/find-your-phone" element={<FindYourPhone/>} />
      <Route path="/it/trova-il-tuo-telefono/" element={<FindYourPhone/>} />
      <Route path="/de/filo-finden-sie-ihr-handy/" element={<FindYourPhone/>} />
      <Route path="/es/filo-find-your-phone/" element={<FindYourPhone/>} />
      <Route path="/fr/filo-find-your-phone/" element={<FindYourPhone/>} />
      <Route path="/business" element={<BusinessHome/>} />
      <Route path="/it/business" element={<BusinessHome/>} />
      <Route path="/de/business" element={<BusinessHome/>} />
      <Route path="/es/business" element={<BusinessHome/>} />
      <Route path="/fr/business" element={<BusinessHome/>} />
      <Route path="/about-us" element={<AboutUs/>} />
      <Route path="/it/chi-siamo" element={<AboutUs/>} />
      <Route path="/de/filo-ueber-uns" element={<AboutUs/>} />
      <Route path="/es/filo-about-us" element={<AboutUs/>} />
      <Route path="/fr/filo-about-us" element={<AboutUs/>} />
      <Route path="/work-with-us" element={<Career/>} />
      <Route path="/it/lavora-con-noi" element={<Career/>} />
      <Route path="/de/filo-arbeite-mit-uns" element={<Career/>} />
      <Route path="/es/filo-career" element={<Career/>} />
      <Route path="/fr/filo-careers" element={<Career/>} />
    </Routes>
    <LanguageSwitcher/>
    <Footer/>
  </Router>

}

const App = () => {
  return  <RouterWrapper/>
}

export default App